<template>

  <Spinner style="margin-top: 150px;" v-if="!LoadCoa"/>
  
  <van-list
  v-if="LoadCoa"
    :finished="LoadCoa"
    class="cursor_card m-t2 m-l-4"
  >
  
  <van-cell class="cell_card_co_a style_card all_border_radius"   v-for="item in coA" :key="item.id" clickable @click="chooseTypeCoA(item.id, item.code_ref, item.type_con)" >
    
    <van-row class="row_card">
      <van-col class="d-content " span="2">

        <van-image
      v-if="item.type_con != 'NU' && StoreCableStructureFamille != 'SLSOH'"
    class="img_inher img_choice_co"
    width="100px"
    fit="cover"
    position="left"
    v-bind:src="buildCoAImgLibre(item)"
  />


  <van-image
      v-if="item.type_con != 'NU' && StoreCableStructureFamille == 'SLSOH'"
    class="img_inher img_choice_co"
    width="100px"
    fit="cover"
    position="left"
    v-bind:src="buildCoAImgSerree(item)"
  />

  <van-image
      v-if="item.type_con == 'NU' "
    class="img_inher img_choice_co"
    width="100px"
    fit="cover"
    position="left"
    v-bind:src="buildCoAImgNu()"
  />


      </van-col>
    <van-col class="d-content " span="2">
  
      <span v-if="item.id == StorePkCoA" style="color:#1989fa">{{ item.type_con }}</span>
      <span v-else>{{ item.type_con }}</span>
  
    </van-col>
  
    <van-col class="d-content " span="2">
      <van-icon v-if="item.id == StorePkCoA" name="success" color="#1989fa" style="vertical-align: top" size="20" />
  
    </van-col>
  
  </van-row>
  
  </van-cell>
  
  </van-list>
  
  
      </template>
      
      
      <script>
      import Spinner from '../../../loader/Spinner.vue'
      export default {
        components: {
          Spinner,
        },
        data() {
          return {
            LoadCoa: false,
            coA: [],
            coAPossibility: [],
          }
        },
        created() {
          this.loadDataSequentiallyCoA();
        },
        computed: {
          /** Connecteur A*/
          StorePkCoA() {
                  return this.globalFunction.existKeyInArray("type", this.$store.state.storeCoA.coA) 
                  ? this.$store.state.storeCoA.coA.type.pkCoA
                  : null 
              },
          StoreCableStructureFamille() {
                  return this.globalFunction.existKeyInArray("structure", this.$store.state.storeCable.cable) 
                  ? this.$store.state.storeCable.cable.structure.codeRefStructureFamille
                  : null 
              },
            },
      methods: {
        buildCoAImgLibre(item){
              if(this.globalFunction.existKeyInArray("type", this.$store.state.storeCable.cable)){
                return this.$store.state.storeGlobal.StoreApi + '/images/connecteur_visu/2mm/profil/Connecteur_' +  item.type_con.replace('/', '') + "_" + this.$store.state.storeCable.cable.type.TypeFibre  + ".png"
              }
                 
                 },
        buildCoAImgSerree(item){
          if(this.globalFunction.existKeyInArray("type", this.$store.state.storeCable.cable)){
            return this.$store.state.storeGlobal.StoreApi + '/images/connecteur_visu/900µ/profil/Connecteur_' +  item.type_con.replace('/', '') + "_" + this.$store.state.storeCable.cable.type.TypeFibre  + ".png"   
          }
        }
          ,
        buildCoAImgNu(){
          if(this.globalFunction.existKeyInArray("type", this.$store.state.storeCable.cable)){
            return this.$store.state.storeGlobal.StoreApi + "/images/connecteur_visu/2mm/profil/Connecteur_NU.png"   
          }
                },

        async loadDataSequentiallyCoA() {
          try {
            await this.getCoA();
            await this.getCoaChoice();
            await this.coAFilter();
          } catch (error) {
            console.error("Une erreur est survenue lors du chargement des données", error);
          }
        },

        async getCoA() {
          try {
            const res = await fetch(this.$store.state.storeGlobal.StoreApi + '/api/preco_cons?' +
              'mode='+ this.$store.state.storeCable.cable.type.ModeFibre +
              '&gauche=true', {
                method: "GET",
                headers: {
                  "Accept": "application/json",
                  "Content-Type": "application/json; charset=utf-8",
                  "Authorization": this.$store.state.storeGlobal.StoreJwtToken
                },
              });
            
            const resultApi = await res.json();
            this.coA = resultApi;
          } catch (error) {
            console.error('Error! Could not reach the API. ', error);
          }
        },

        async getCoaChoice() {
          try {
            const res = await fetch(this.$store.state.storeGlobal.StoreApi + '/api/logique/preco_cons_choice_co?' +
              'nbFibre='+ this.$store.state.storeCable.cable.nombre.nbFibre +
              '&structure='+ this.$store.state.storeCable.cable.structure.codeStructure +
              '&mode='+ this.$store.state.storeCable.cable.type.TypeFibreCodeRef +
              '&cote=a', {
                method: "GET",
                headers: {
                  "Accept": "application/json",
                  "Content-Type": "application/json; charset=utf-8",
                  "Authorization": this.$store.state.storeGlobal.StoreJwtToken
                },
              });
            
            const resultApi = await res.json();
            this.coAPossibility = resultApi;
          } catch (error) {
            console.error('Error! Could not reach the API. ', error);
          }
        },

        async coAFilter() {
          if (!Array.isArray(this.coA)) {
            console.error('coA is not initialized or not an array');
            return;
          }

          this.coA = this.coA.filter(item => Object.keys(this.coAPossibility).includes(item.type_con));
          this.LoadCoa = true;
        },

        chooseTypeCoA(pkCoA, codeRefCoA, TypeCoA){

          this.obj = {  
          'coA' : {
            'type' : {
              pkCoA:pkCoA,
              codeRefCoA: codeRefCoA,
              TypeCoA: TypeCoA
        }
        }};
       
        this.$store.commit('SET_CHOICE_COA', this.obj )


        }
        
      },
      
      
      }
      </script>